














import { CartScopeEq } from '@/models/cart/group/scope'
import AppId from '@/util/appid'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import RecommendItems from './RecommendItems.vue'

@Component({
  components: {
    RecommendItems,
  },
})
export default class PopularItems extends Vue {
  @Prop({ required: true })
  scope: CartScopeEq

  @Prop({ required: true })
  itemListUrl: string

  @Prop({ default: null })
  brand: string | null

  get appId(): string {
    return AppId.getByBrandName(this.brand)
  }

  get popularItemsQuery(): object {
    return {
      orderby: 'weight',
      // ~aux 無しでは belonging_to に埋め込まれる ROOT の aux が返らない（Engine の with 修飾子）
      with: 'belonging_to~aux,part,stock~detail,like,indexsummary',
      'part.status_id': 1,
    }
  }
}
